import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/relatorios/painel/PainelApiClient'

export default {
	async [actionTypes.RELATORIOS.PAINEL.BUSCAR_LISTAGEM]() {
		const { data } = await api.buscarListagem()
		return data
	},
}
